import { queryOptions } from "@tanstack/react-query";
import { fetchOccPageData, sanitizePageDataSearch } from "./pageDataClient";
import { pageDataKeys } from "./pageDataKeys";
import type { PageInitialDataResult } from "./pageInitialDataTypes";
import type { PdpPageInitialData } from "./pdpPageInitialData";

export const pdpPageQueryOptions = (productCode: string, search = "") => {
  const sanitizedSearch = sanitizePageDataSearch(search);
  return queryOptions({
    queryKey: pageDataKeys.pdp(productCode, sanitizedSearch),
    queryFn: () =>
      fetchOccPageData<PageInitialDataResult<PdpPageInitialData>>(`/page-data/p/${productCode}${sanitizedSearch}`),
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    retry: 1,
  });
};
